import styled from "@emotion/styled";

import { ChartTooltipContent } from "components/ui/chart/Chart";

/**
 * The shared chart tooltip with a "Click to inspect" hint, for charts whose periods open their
 * transactions. The shared tooltip has no slot for extra content; its wrapper is a grid, so the
 * pseudo-element lands as a last row with the same gap as the values above it.
 */
export const ClickToInspectTooltipContent = styled(ChartTooltipContent)(({ theme }) => ({
  "&::after": {
    content: '"Click to inspect"',
    color: theme.colors.sysTextPlaceholder,
  },
}));
